module.exports = __webpack_public_path__ + "assets/images/favicon-e10749.png";


//////////////////
// WEBPACK FOOTER
// ./src/less/assets/images/favicon.png
// module id = 1158
// module chunks = 0